import { render, staticRenderFns } from "./InstallService.vue?vue&type=template&id=53538940&"
import script from "./InstallService.vue?vue&type=script&lang=js&"
export * from "./InstallService.vue?vue&type=script&lang=js&"
import style0 from "./InstallService.vue?vue&type=style&index=0&id=53538940&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports